import { Component } from '@angular/core';

@Component({
  selector: 'map-loading',
  templateUrl: './map-loading.component.html',
  styleUrls: ['./map-loading.component.scss']
})
export class MapLoadingComponent { }
